export default {
  namespaced: true,
  state: {
    login_visible: false,
    login_redirect_url: '/dashboard',

    payment_error_message: null,
    payment_error_show: false,
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: false,

    showFoodAddModal: false,
    showWeighInModal: false,
    
    showSnackbar: false,
    snackbartype: 'success',
    snackbarmessage: '',

    pageLoading: false
  },
  mutations: {
    login_dialog(state, payload) {
      state.login_visible = payload.show;

      // Don't reset the URI when closing the dialog
      if (payload.show) {
        state.login_redirect_url = payload.redirect_url ? payload.redirect_url : '/dashboard';
      }
    },
    show_payment_error(state, payload) {
      state.payment_error_show = payload;
    },
    payment_error_message(state, payload) {
      state.payment_error_message = payload;
    },
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    set_drawer (state, payload) {
      state.drawer = payload
    },
    setFoodAddModal(state, payload) {
      state.showFoodAddModal = payload;
    },
    setWeighInModal(state, payload) {
      state.showWeighInModal = payload;
    },
    showSnackbar(state, payload) {
      state.snackbarmessage = payload.snackbarMessage;
      state.snackbartype = payload.snackbarType;
      state.showSnackbar = true;
      setTimeout(() => {
        state.showSnackbar = false;
      }, 6000);
    },
    pageLoading(state, payload) {
      state.pageLoading = payload;
    },
  },
  actions: {
    // send({commit}, payload) {
    // }
  },
  getters: {
    // sent(state) {
    //   return state.sent
    // }
  }
}